// src/Blog/posts.js
import myFirstPost from "./Posts/first";
export const posts = [
  {
    id: 'my-first-post',
    title: 'Test post for math and code format',
    date: 'December 22, 2025',
    description: 'A post with LaTeX and code examples',
    content: myFirstPost,
    tags: ['math', 'code']
  }
];
